import DocumentTemplateRepository from "../domain/data/DocumentTemplateRepository";
import DocumentTemplate from "../domain/entities/DocumentTemplate";
import Package from "../domain/entities/Package";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APIDocumentTemplateRepository
  implements DocumentTemplateRepository
{
  private client = new AwsApiClient();

  async getDocumentTemplate(
    user: User,
    documentTemplateId: string
  ): Promise<DocumentTemplate | undefined> {
    try {
      const response = await this.client.get(
        `/api/template/${user.organization.id}/${user.id}/${documentTemplateId}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  async loadDocTemplateByCampaign(
    userId: string,
    organizationId: string,
    campaignId: string
  ): Promise<DocumentTemplate | undefined> {
    try {
      const response = await this.client.get(
        `/api/templateresponse/${organizationId}/${userId}/${campaignId}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  async saveDocumentTemplate(
    user: User,
    documentTemplate: DocumentTemplate
  ): Promise<DocumentTemplate> {
    try {
      const response = await this.client.post(
        `/api/template`,
        documentTemplate
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  async deleteDocumentTemplate(
    user: User,
    documentTemplate: DocumentTemplate
  ): Promise<boolean> {
    try {
      const response = await this.client.delete(
        `/api/template/${user.organization.id}/${user.id}/${documentTemplate.id}`, "none"
      );
      return true;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  async getDocumentTemplates(
    user: User,
    documentPackage?: Package,
    includeFiles?: boolean
  ): Promise<DocumentTemplate[]> {
    try {
      const url = includeFiles 
        ? `/api/templates/${user.organization.id}/${user.id}?includeFiles=true`
        : `/api/templates/${user.organization.id}/${user.id}`;
      const response = await this.client.get(url);
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  async documentTemplateSignaturePosition(
    user: User,
    documentTemplate: DocumentTemplate,
    newFile: string
  ): Promise<DocumentTemplate> {
    try {
      const response = await this.client.post(
        `/api/template/${documentTemplate.id}/savesignatureposition`,
        { signaturePositionFile: newFile }
      );
      documentTemplate.signaturePositionFile = newFile;
      return documentTemplate;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
  async translatePDF(
    documentTemplateId: string,
    language: string
  ): Promise<string> {
    try {
      const response = await this.client.postExternal(
        `/api/template/translate/${documentTemplateId}/${language}`, null, "text"
      );
      if (response === null || response === "") {
        throw new Error("PDF not obtained");
      }
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
